const getView = () => {
  const DictCtxView = {
    model: "sale.sale",
    domain: [["state", "=", "draft"]],
    form_action: [],
    table_action: [],
    activeSearch: true,
    pagination: [],
    limit: 20,
    selectable: null,
    title: { field: "number", model: true },
    webfields: {
      number: { type: "char", readOnly: true, searchable: true },
      party: {
        type: "many2one",
        model: "party.party",
        searchable: true,
        readOnly: true,
      },
      sale_date: {
        type: "date",
        readOnly: true,
        default: () => new Date(),
        required: true,
      },
      state: {
        type: "char",
        readOnly: true,
        translate: true,
        default: "draft",
      },

      description: { type: "char", readOnly: true, searchable: true },
      add: {
        type: "button",
        color: "blue",
        icon: "fi fi-rr-add",
      },
    },
    webtree: [
      { name: "number", width: "20%" },
      { name: "sale_date", width: "25%" },
      { name: "party", width: "25%" },
      { name: "description", width: "25%" },
      { name: "add", width: "25%" },
    ],
    webform: [],
  };

  return DictCtxView;
};

export default { ctxView: getView };
